module.exports = "/_next/static/images/drive-business-growth-525dd0c4f14052c82f9f4e11d6f5eb0f.svg";